import React, { Component } from 'react';
import axios from 'axios';
import moment from 'moment';
import { APIURL } from '../../config';
import { Card, CardActions, CardContent, CircularProgress, TextField, InputAdornment, Typography, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, IconButton, Icon } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import CloseIcon from '@mui/icons-material/Close';
import { createTheme } from '@mui/material/styles';
import { ThemeProvider } from '@mui/styles';
import MUIRichTextEditor from 'mui-rte';
import NoteFormv2 from '../../components/forms/NoteForm/NoteFormv2';

const myTheme = createTheme({
    overrides: {
        MUIRichTextEditor: {
            anchorLink: {
                color: "lightblue",
                textDecoration: "underline",
            },
        },
    },
});

class HouseholdNotes extends Component {
    constructor(props) {
        super(props);
        this.state = {
            notes: [],
            loading: true,
            searchTerm: '',
            householdMembers: [],
            showAddNote: false,
            showAddVoiceNote: false,
            isAdding: false,
            editNote: null,
            isNoteDirty: false,
            showExitConfirm: false
        };
    }

    componentDidMount() {
        this.fetchNotes();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.household_id !== this.props.household_id || prevProps.members !== this.props.members) {
            this.fetchNotes();
        }
    }

    isJSON(str) {
        try {
            JSON.parse(str);
            return true;
        } catch (e) {
            return false;
        }
    }

    fetchNotes = async () => {
        this.setState({ loading: true });
        try {
            const { household_id } = this.props;

            // Fetch household members
            const members = this.props.members || (await axios.get(`${APIURL}/households/members`, {
                params: { household_id }
            })).data || [];
            const customers = members.filter(m => m.customer_id !== null);

            this.setState({ householdMembers: customers });

            // Fetch notes for each customer
            let allNotes = [];
            for (const member of customers) {
                try {
                    // Fetch regular notes
                    const notesResponse = await axios.get(`${APIURL}/comments`, {
                        params: { customer_id: member.customer_id, empID: this.props.user?.emp_id }
                    });
                    let customerNotes = notesResponse.data;

                    // Fetch note details for each note
                    customerNotes = await Promise.all(customerNotes.map(async (note) => {
                        try {
                            const noteDataResponse = await axios.get(`${APIURL}/comments/details`, {
                                params: { comment_id: note.comment_id, empID: this.props.user?.emp_id }
                            });
                            const noteData = noteDataResponse.data[0];
                            return {
                                ...noteData,
                                customer_name: member.cus_name,
                                customer_id: member.customer_id
                            };
                        } catch (err) {
                            console.error('Error fetching note details:', err);
                            return null;
                        }
                    }));

                    customerNotes = customerNotes.filter(note => note !== undefined && note !== null);

                    // Fetch audio notes
                    try {
                        const audioResponse = await axios.get(`${APIURL}/audio_note`, {
                            params: { customer_id: member.customer_id }
                        });
                        const audioNotes = audioResponse.data.map((audioNote) => ({
                            ...audioNote,
                            created_at: audioNote.submitted,
                            customer_name: member.cus_name,
                            customer_id: member.customer_id
                        }));
                        customerNotes.push(...audioNotes);
                    } catch (err) {
                        console.error('Error fetching audio notes:', err);
                    }

                    allNotes.push(...customerNotes);
                } catch (error) {
                    console.error(`Error fetching notes for customer ${member.customer_id}:`, error);
                }
            }

            // Sort by date
            allNotes.sort((a, b) => {
                return moment(a.created_at).isBefore(moment(b.created_at)) ? 1 : -1;
            });

            this.setState({ notes: allNotes, loading: false });
        } catch (error) {
            console.error('Error fetching household notes:', error);
            this.setState({ loading: false });
        }
    };

    getFilteredNotes = () => {
        const { notes, searchTerm } = this.state;
        if (!searchTerm.trim()) return notes;

        const searchRegex = new RegExp(searchTerm, 'i');
        return notes.filter(note => {
            return (
                searchRegex.test(note.note_title || '') ||
                searchRegex.test(note.comment_text || '') ||
                searchRegex.test(note.customer_name || '') ||
                searchRegex.test(note.emp_first_name || '') ||
                searchRegex.test(note.emp_last_name || '') ||
                searchRegex.test(note.tas_title || '') ||
                searchRegex.test(note.pro_title || '')
            );
        });
    };

    renderNoteCard = (note) => {
        var Buffer = require('buffer/').Buffer;
        let audioSrc;

        if (note.audio_note) {
            const decodedData = Buffer.from(note.audioNote[0].audio_note, 'base64');
            const blob = new Blob([decodedData], { type: 'audio/wav' });
            audioSrc = URL.createObjectURL(blob);
        }

        return (
            <Card key={note.comment_id || note.id} sx={{ backgroundColor: '#d4f1f9' }}>
                <CardActions sx={{ paddingLeft: '16px', paddingRight: '16px', display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                    <div style={{ flex: 1, minWidth: 0 }}>
                        <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', minWidth: 0 }}>
                            <div style={{ flex: 1, minWidth: 0 }}>
                                <div style={{ minWidth: 0 }}>
                                    {note.note_title && <h6 style={{ marginBottom: '0px', marginTop: '0px', marginRight: 10, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{note.note_title}</h6>}
                                    {!note.note_title ?
                                        <h6 style={{ marginBottom: '0px', marginTop: '0px', marginRight: 10, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{note.tas_title ? note.tas_title : note.pro_title ? note.pro_title : note.customer_name}</h6> :
                                        <div style={{ marginBottom: '0px', marginTop: '0px', color: 'gray', fontSize: 13 }}>{note.tas_title ? note.tas_title : note.pro_title ? note.pro_title : note.customer_name}</div>
                                    }
                                    <div style={{ color: 'gray', fontSize: 13, marginBottom: 0, marginTop: 0 }}>
                                        {this.props.customerLabel || 'Customer'}: {note.customer_name}
                                    </div>
                                </div>
                            </div>
                            <div style={{ display: 'flex', alignItems: 'flex-start', marginLeft: 20 }}>
                                <div style={{ fontSize: 13, color: 'gray', display: 'flex', flexDirection: 'column', alignItems: 'flex-end' }}>
                                    <span style={{ whiteSpace: 'nowrap' }}>
                                        Created by {note.emp_first_name + ' ' + note.emp_last_name} at {moment(note.created_at).format('hh:mm A')} on {moment(note.created_at).format('MM/DD/YYYY')}
                                    </span>
                                    {!!note.updated_by && !!note.updated_at &&
                                        <span style={{ whiteSpace: 'nowrap' }}>
                                            Updated by {note.updated_emp_first_name + ' ' + note.updated_emp_last_name} at {moment(note.updated_at).format('hh:mm A')} on {moment(note.updated_at).format('MM/DD/YYYY')}
                                        </span>
                                    }
                                </div>
                                {!note.audioNote &&
                                    <IconButton
                                        style={{ marginLeft: 8 }}
                                        onClick={() => this.setState({ editNote: note })}
                                    >
                                        <Icon style={{ fontSize: '16px' }} baseClassName="fas" className="fa-edit" />
                                    </IconButton>
                                }
                            </div>
                        </div>
                    </div>
                </CardActions>
                <CardContent sx={{ paddingBottom: '16px', paddingTop: '0px' }}>
                    <hr style={{ marginBottom: '10px', marginTop: '0px', backgroundColor: '#e2ecfa' }}></hr>
                    {!note.audioNote &&
                        <ThemeProvider theme={myTheme}>
                            <MUIRichTextEditor
                                defaultValue={this.isJSON(note.comment_text) ? note.comment_text : `{"blocks":[{"key":"block1","text":"${note.comment_text.replace(/\n/g, ' ').replace(/\t/g, ' ').replace(/"/g, '\\"')}","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}}],"entityMap":{}}`}
                                readOnly={true}
                                toolbar={false}
                            />
                        </ThemeProvider>}
                    {note.audioNote && <audio controls src={audioSrc} />}
                </CardContent>
            </Card>
        );
    };

    render() {
        const { loading, searchTerm } = this.state;
        const filteredNotes = this.getFilteredNotes();

        if (loading) {
            return (
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '400px' }}>
                    <CircularProgress />
                </div>
            );
        }

        return (
            <div>
                <div style={{ marginBottom: '20px', display: 'flex', gap: '10px' }}>
                    <TextField
                        value={searchTerm}
                        onChange={(e) => this.setState({ searchTerm: e.target.value })}
                        placeholder="Search notes..."
                        variant="outlined"
                        size="small"
                        style={{ flex: 1 }}
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <SearchIcon />
                                </InputAdornment>
                            ),
                        }}
                    />
                    <Button 
                        variant="contained" 
                        color="primary" 
                        disabled={this.state.isAdding}
                        onClick={() => this.setState({ showAddNote: true, isAdding: true, showAddVoiceNote: false })}
                    >
                        Add Note
                    </Button>
                    <Button 
                        variant="contained" 
                        color="primary" 
                        disabled={this.state.isAdding}
                        onClick={() => this.setState({ showAddNote: true, isAdding: true, showAddVoiceNote: true })}
                    >
                        Add Voice Note
                    </Button>
                </div>

                {filteredNotes.length === 0 ? (
                    <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', minHeight: '300px' }}>
                        <i className="far fa-sticky-note" style={{ fontSize: '80px', color: '#ccc', marginBottom: '20px' }}></i>
                        <Typography variant="h6" color="textSecondary">
                            {searchTerm ? 'No notes found matching your search' : `No notes found for this ${this.props.entityLabel || 'household'}`}
                        </Typography>
                    </div>
                ) : (
                    <div style={{ maxHeight: 'calc(100vh - 350px)', overflowY: 'auto' }}>
                        <div style={{
                            display: 'grid',
                            gridTemplateColumns: 'repeat(2, 1fr)',
                            gap: '20px'
                        }}>
                            {filteredNotes.map(note => this.renderNoteCard(note))}
                        </div>
                    </div>
                )}

                <Dialog fullWidth={true} maxWidth={'lg'} open={this.state.showAddNote} onClose={() => {
                    if (this.state.isNoteDirty) {
                        this.setState({ showExitConfirm: true });
                    } else {
                        this.setState({ showAddNote: false, showAddVoiceNote: false, isAdding: false });
                    }
                }}>
                    <DialogActions>
                        <IconButton
                            aria-label="close"
                            color="inherit"
                            sx={{ p: 0.25 }}
                            onClick={() => {
                                if (this.state.isNoteDirty) {
                                    this.setState({ showExitConfirm: true });
                                } else {
                                    this.setState({ showAddNote: false, showAddVoiceNote: false, isAdding: false });
                                }
                            }}
                        >
                            <CloseIcon />
                        </IconButton>
                    </DialogActions>
                    <DialogContent sx={{ paddingTop: '0px' }}>
                        <NoteFormv2 
                            checkTokenExpiry={this.props.checkTokenExpiry}
                            company_id={this.props.user?.comp_id} 
                            mode='add' 
                            isVoiceNote={this.state.showAddVoiceNote} 
                            user={this.props.user} 
                            customer_id={null}
                            onSubmit={() => {
                                this.setState({ showAddNote: false, showAddVoiceNote: false, isAdding: false, isNoteDirty: false });
                                this.fetchNotes();
                            }}
                            onDirtyChange={(isDirty) => this.setState({ isNoteDirty: isDirty })}
                        />
                    </DialogContent>
                </Dialog>

                <Dialog fullWidth={true} maxWidth={'lg'} open={this.state.editNote != null}>
                    <DialogActions>
                        <IconButton
                            aria-label="close"
                            color="inherit"
                            sx={{ p: 0.25 }}
                            onClick={() => {
                                if (this.state.isNoteDirty) {
                                    this.setState({ showExitConfirm: true });
                                } else {
                                    this.setState({ editNote: null, isNoteDirty: false });
                                }
                            }}
                        >
                            <CloseIcon />
                        </IconButton>
                    </DialogActions>
                    <DialogContent sx={{ paddingTop: '0px' }}>
                        <NoteFormv2 
                            checkTokenExpiry={this.props.checkTokenExpiry}
                            mode='edit' 
                            project_id={this.state.editNote?.proj_id} 
                            task_id={this.state.editNote?.tas_id} 
                            note_id={this.state.editNote?.comment_id} 
                            user={this.props.user} 
                            customer_id={this.state.editNote?.customer_id} 
                            company_id={this.props.user?.comp_id} 
                            onSubmit={() => {
                                this.setState({ editNote: null, isNoteDirty: false });
                                this.fetchNotes();
                            }}
                            onDirtyChange={(isDirty) => this.setState({ isNoteDirty: isDirty })}
                        />
                    </DialogContent>
                </Dialog>

                <Dialog open={this.state.showExitConfirm} onClose={() => this.setState({ showExitConfirm: false })}>
                    <DialogTitle>Discard Changes?</DialogTitle>
                    <DialogContent>
                        <DialogContentText>You have unsaved changes. Are you sure you want to discard them?</DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={() => this.setState({ showExitConfirm: false })}>Cancel</Button>
                        <Button onClick={() => {
                            this.setState({ 
                                editNote: null, 
                                showAddNote: false, 
                                showAddVoiceNote: false, 
                                isAdding: false, 
                                isNoteDirty: false, 
                                showExitConfirm: false 
                            });
                        }} color='primary'>Discard</Button>
                    </DialogActions>
                </Dialog>
            </div>
        );
    }
}

export default HouseholdNotes;
